import Kernel from 'Core/Kernel';

/**
 * Checks if any image is blocked by CSP and replaces it with a proxy
 *
 */
window.addEventListener('securitypolicyviolation', async (event) => {
    if (event.effectiveDirective === 'img-src') {
        document.querySelector(`img[src="${event.blockedURI}"]`).src =
            'https://image-proxy.tschmutz.workers.dev/' + event.blockedURI;
    }
});

/**
 * @var Config Entrypoint configuration
 */
export default (Config, isContextPublic = false) => {
    window.kernel = new Kernel(Config, isContextPublic);
};
